module.exports = __webpack_public_path__ + "static/img/bj_gift_box.0ff28de.png";